import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["checkbox", "link", "emptyHint"]

    connect() {
        this.updateUrl()
    }

    updateUrl() {
        this.linkTargets.forEach(link => {
            const url = new URL(link.href)

            // Clear existing fields
            url.searchParams.delete("fields[]")

            // Append selected fields
            this.checkboxTargets.forEach(checkbox => {
                if (checkbox.checked) {
                    url.searchParams.append("fields[]", checkbox.value)
                }
            })

            link.href = url.toString()
        })

        this.updateLinkAvailability()
    }

    toggleAll(event) {
        const checked = event.target.checked
        this.checkboxTargets.forEach(checkbox => {
            checkbox.checked = checked
        })
        this.updateUrl()
    }

    selectedCount() {
        return this.checkboxTargets.filter(checkbox => checkbox.checked).length
    }

    updateLinkAvailability() {
        const hasSelection = this.selectedCount() > 0

        this.linkTargets.forEach(link => {
            link.classList.toggle("pointer-events-none", !hasSelection)
            link.classList.toggle("opacity-50", !hasSelection)
            link.setAttribute("aria-disabled", String(!hasSelection))
            link.tabIndex = hasSelection ? 0 : -1
        })

        if (this.hasEmptyHintTarget) {
            this.emptyHintTarget.classList.toggle("hidden", hasSelection)
        }
    }
}
